module.exports = __webpack_public_path__ + "img/guardian_monkeybusiness.467f943d.png";